import { useEffect, useState, type Dispatch, type SetStateAction } from 'react';

const sessionMemory = new Map<string, unknown>();

export function resetSessionMemoryForTests(): void {
  sessionMemory.clear();
}

/**
 * Component state that survives unmount for the sidebar's lifetime. Views
 * unmount during loading phases; a keyed entry keeps disclosure state stable
 * across remounts. An undefined key behaves like plain useState.
 */
export function useSessionMemory<T>(
  key: string | undefined,
  initial: () => T
): [T, Dispatch<SetStateAction<T>>] {
  const [value, setValue] = useState<T>(() =>
    key !== undefined && sessionMemory.has(key) ? (sessionMemory.get(key) as T) : initial()
  );
  useEffect(() => {
    if (key !== undefined) sessionMemory.set(key, value);
  }, [key, value]);
  return [value, setValue];
}
